/**
 * Esquemas de validación de entradas para formularios.
 * Ordenadas por categorías y alfabéticamente.
 * @returns {schema}
 */
import {object, string, date, array as arraySchema, boolean} from 'yup';
/* Categoría: Entidades */
const doctorSchema = object(personSchema).shape({
  matricula: string().required(function() {
    throw new Error('Indicar la matrícula.');
  }).min(2).max(20).trim(),
});

const personSchema = object().shape({
  fname: string().required().min(2).max(20).trim(),
  mname: string().max(20).trim().ensure(),
  lname: string().required().min(2).max(20).trim(),
  llname: string().max(20).trim().ensure(),
  gender: string().required(),
  born: date('Y-m-d').required().max(formatDate(), function() {
    throw new Error('Nacimiento debe ser antes de hoy.');
  }),
});

const emailSchema = object().shape({
  email: string().required().email().trim(),
  primary: boolean(),
  status: string().nullable().trim(),
});

/* Categoría: Formatos */
/**
 * @return {Date} fecha actual
 */
function formatDate() {
  return (new Date()).toISOString().split('T')[0];
}
/**
 * Devuelve un true si cumple con la validacion, caso contrario false
 * @param {String} identificationType Objeto con Expresion Regular a comparar
 * @param {String} identification Identificacion del Usuario
 * @return {Boolean}
 */
function validateIdentification(identificationType, identification) {
  const regExp = new RegExp(identificationType.regExp);
  return regExp.test(identification);
}
/**
 * @return {Date} fecha actual
 */
function todayDate() {
  let fecha = new Date();
  const z = fecha.getTimezoneOffset();
  const v = fecha.valueOf();
  const r = v - z * 1000*60;
  fecha = new Date(r);
  return fecha.toISOString().split('T')[0];
}

export {
  arraySchema,
  doctorSchema,
  emailSchema,
  personSchema,
  todayDate,
  validateIdentification,
};
